module.exports = __webpack_public_path__ + "static/media/kolorowanka_4.63e31e71.png";